import moment from 'moment';

import { IProcessXmlFormFieldParsed } from '~/store/modules/processes/types';

import { createFieldValidation } from '../validation/factory';
import { Validations } from '../validation/types';
import {
  FieldVariableType,
  ProcessForm,
  ProcessFormEnumField,
  ProcessFormEnumOption,
  ProcessFormField,
  ProcessFormValues,
  RawProcessForm,
  RawProcessFormEnumOption,
} from './types';

export function getInitialFormValues(form: ProcessForm): ProcessFormValues {
  const initialValues: ProcessFormValues = {};

  form.forEach((input) => {
    const {
      id,
      defaultValue,
      validations: { isDateTime },
    } = input;

    if (isDateTime) {
      initialValues[id] = convertCamundaDateToBrazilianDate(
        defaultValue as string,
      );
    } else if (hasEnumOptions(input)) {
      initialValues[id] = convertEnumType(input);
    } else {
      initialValues[id] = defaultValue;
    }

    initialValues[id] = isDateTime
      ? convertCamundaDateToBrazilianDate(defaultValue as string)
      : defaultValue;
  });

  return initialValues;
}

function convertCamundaDateToBrazilianDate(date: string) {
  if (date === undefined) {
    return null;
  }
  return moment(date, 'YYYY-MM-DDTHH:mm:ss.SSS-0300', true).format(
    'DD/MM/YYYY',
  );
}

function convertEnumType(input: ProcessFormEnumField) {
  const { options, defaultValue } = input;

  const option = options.find((option) => option.value === defaultValue);
  return option;
}

export function createCamundaForm(rawProcessForm: RawProcessForm): ProcessForm {
  const processForm: ProcessForm = [];

  rawProcessForm.forEach((input) => {
    const { id, label, type, defaultValue } = input.props;

    const options = parseFieldOptions(input.value);

    const validations = input.properties
      ? extractFieldValidationsFromProperties(input.properties)
      : {};

    if (type === 'date') validations.isDateTime = true;

    const processFormField = {
      id,
      defaultValue,
      label,
      type: type as FieldVariableType,
      validations,
      options,
    };

    processForm.push(processFormField);
  });

  return processForm;
}

function parseFieldOptions(
  value?: RawProcessFormEnumOption | Array<RawProcessFormEnumOption>,
): Array<ProcessFormEnumOption> | undefined {
  if (!value) return undefined;

  const values = Array.isArray(value) ? value : [value];

  const options = values.map(({ props }) => ({
    value: props.id,
    label: props.name,
  }));

  return options;
}

function extractFieldValidationsFromProperties({
  property,
}: IProcessXmlFormFieldParsed['properties']): Validations {
  const propertyList = Array.isArray(property) ? property : [property];
  let validations: Validations = {};

  propertyList.forEach((property) => {
    const { id, value } = property.props;
    validations = {
      ...validations,
      ...createFieldValidation(id, value),
    };
  });

  return validations;
}

export function hasEnumOptions(
  field: ProcessFormField,
): field is ProcessFormEnumField {
  return !!(field as ProcessFormEnumField).options;
}
